import { useChangelogs, capitalizeName, parseMessageContent } from '../middleware/Changelogs';
import Sidebar from '../components/Sidebar';
import { SkeletonChangelogRow, staggerStyle } from '../components/Skeleton';
import '../styles/Changelogs.css';

const Updates = () => {
    const { changelogs, loading } = useChangelogs();

    return (
        <div className="content">
            <Sidebar />
            <div className='main-content'>
                <h1>Changelogs</h1>
                <p>Stay tuned for the latest updates and changelogs from ISN Network!</p>
                {loading ? (
                    Array.from({ length: 4 }, (_, i) => <SkeletonChangelogRow key={i} />)
                ) : (
                    <ul>
                        {changelogs.map((msg, i) => (
                            <li
                                key={msg.id}
                                className="discord-changelog stagger-item"
                                style={staggerStyle(i)}
                            >   
                                <div className="changelog-header">
                                    <p>{capitalizeName(msg.author)}</p>
                                </div>
                                <div className="changelog-content"
                                    dangerouslySetInnerHTML={{ __html: parseMessageContent(msg.content) }}
                                ></div>
                                <div className="changelog-footer">
                                    <small className="Timestamp"> At {new Date(msg.timestamp).toLocaleString()}</small>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
export default Updates;
